<script>

import api from "@/axios";
import Loader from "../components/loader";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { revenueChart } from "../../views/contacts/data-profile";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Loader, Layout, PageHeader, },
  methods: {
    sucesso(){
      Swal.fire("Obrigado!", "Seu pedido foi confirmado com sucesso.", "success").then(result => {
        if (result.value) {
          this.$router.push(
              this.$route.query.redirectFrom || {
                name: "OrctoLista",
              }
          );
        }
      });
    },
    listarKits(){
      this.loadingKits = true
      setTimeout(() => {
        this.loadingKits = false
      }, 1000);

    },
    selecionaKit(){
      console.log('selecionaKit')
      this.loadingComponentes = true
      setTimeout(() => {
        this.loadingComponentes = false
      }, 1000);
    }
  },
  mounted() {
    console.log('mounted orcto-detalhe')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      this.loadingKits = false


      this.componentesData = [
        {
          codigo: '27627',
          descricao: 'COND. HOR VRF - Q/F - 220V/1F',
          dtDisp: '30/03/2023',
          quantidade: 10,
          valor: 1.544
        },
        {
          codigo: '21146',
          descricao: 'CONTROLE REMOTO ',
          dtDisp: '30/03/2023',
          quantidade: 1,
          valor: 22
        },
        {
          codigo: '19372',
          descricao: 'KIT INST. E AUTOMAÇÃO',
          dtDisp: '30/03/2023',
          quantidade: 1,
          valor: 801
        },
        {
          codigo: '13118',
          descricao: 'CAIXA DE DISTRIBUIÇÃO - 4 EVAPS',
          dtDisp: '30/03/2023',
          quantidade: 1,
          valor: 2.004
        }
      ]

      this.produtosData = [
        {
          id: 3,
          product: require('@/assets/images/product-mobagile/daikin-logo.png'),
          discount: 14,
          name: 'Daikin Fit',
          oldprice: 177,
          newprice: 101.444,
          feature: ['Fit Type: Regular Fit', 'highest quality fabric', 'Suitable for all weather condition', 'Excellent Washing and Light Fastness'],
          specification: [{
            key: 'size',
            value: 'M'
          },
            {
              key: 'color',
              value: 'Black'
            }],
          images: [require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-2.png')],
          colorVariant: [{
            key: 'Black',
            value: require('@/assets/images/product/img-3.png')
          },
            {
              key: 'Yellow',
              value: require('@/assets/images/product/img-3.png')
            }]
        },


        {
          id: 3,
          product: require('@/assets/images/product-mobagile/samsung-logo.png'),
          discount: 14,
          name: 'Samsung',
          oldprice: 177,
          newprice: 94.877,
          feature: ['Fit Type: Regular Fit', 'highest quality fabric', 'Suitable for all weather condition', 'Excellent Washing and Light Fastness'],
          specification: [{
            key: 'size',
            value: 'M'
          },
            {
              key: 'color',
              value: 'Black'
            }],
          images: [require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-2.png')],
          colorVariant: [{
            key: 'Black',
            value: require('@/assets/images/product/img-3.png')
          },
            {
              key: 'Yellow',
              value: require('@/assets/images/product/img-3.png')
            }]
        },

        {
          id: 1,
          product: require('@/assets/images/product-mobagile/midea-logo.png'),
          discount: 10,
          name: 'Midea',
          oldprice: 450,
          newprice: 80.544,
          feature: ['Fit Type: Regular Fit', 'highest quality fabric', 'Suitable for all weather condition', 'Excellent Washing and Light Fastness'],
          specification: [{
            key: 'size',
            value: 'M'
          },
            {
              key: 'color',
              value: 'Red'
            }],
          images: [require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png'), require('@/assets/images/product/img-6.png')],
          colorVariant: [{
            key: 'Red',
            value: require('@/assets/images/product/img-1.png')
          },
            {
              key: 'Black',
              value: require('@/assets/images/product/img-1.png')
            }]
        },
        {
          id: 2,
          product: require('@/assets/images/product-mobagile/carrier-logo.png'),
          name: 'Carrier Extra Power',
          discount: 20,
          oldprice: 225,
          newprice: 75.801,
          feature: ['Fit Type: Regular Fit', 'highest quality fabric', 'Suitable for all weather condition', 'Excellent Washing and Light Fastness'],
          specification: [{
            key: 'size',
            value: 'M'
          },
            {
              key: 'Color',
              value: 'Light Blue'
            }],
          images: [require('@/assets/images/product/img-2.png'), require('@/assets/images/product/img-1.png'), require('@/assets/images/product/img-5.png'), require('@/assets/images/product/img-3.png')],
          colorVariant: [{
            key: 'Red',
            value: require('@/assets/images/product/img-2.png')
          },
            {
              key: 'Yellow',
              value: require('@/assets/images/product/img-2.png')
            },
            {
              key: 'Green',
              value: require('@/assets/images/product/img-2.png')
            }]
        }

      ]

    });
  },
  data() {
    return {
      showModalComponente: false,
      loadingKits: true,
      loadingComponentes: false,
      produtosData: null,
      componentesData: null,
      revenueChart: revenueChart,
      title: "Novo Orçamento (Inteligência Artificial)",
      items: [
        {
          text: "Orçamentos",
          href: "/orcamentos/list"
        },
        {
          text: "Novo Orçamento",
          active: true
        }
      ],
      statData: [
        {
          icon: "bx bx-power-off",
          title: "Capacidade (HP)",
          value: "125"
        },
        {
          icon: "bx bx-hourglass",
          title: "Tempo Abertura (Dias)",
          value: "2"
        },
        {
          icon: "bx bx-package",
          title: "Valor Total",
          value: "R$ 36.000,52"
        }
      ],
      listaComponentes1: {


        "codigo": "23847",
        "descricao": "COND. HOR VRF - Q/F - 220V/1F"


      }
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">Campanha SAMSUNG</h5>
                  <p>toda linha com entrega imediata</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-24">
                    -10%
                  </span>
                </div>

                <h5 class="font-size-15 text-truncate">1.480</h5>
                <p class="text-muted mb-0 text-truncate">Disponível</p>
              </div>

              <div class="col-sm-8">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-size-15">Potência (HP)</h5>
                      <p class="text-muted mb-0">
                        <input type="text" class="form-control" />
                      </p>
                    </div>
                    <div class="col-6">
                      <h5 class="font-size-15">Tipo</h5>
                      <p class="text-muted mb-0">
                        <select class="form-select">
                          <option value="BT" selected="">COND. HOR VRF - FRIO - 220V/1F</option>
                          <option value="ET">HI-WAL</option>
                          <option value="LT">TETO</option>
                        </select>
                      </p>
                    </div>
                  </div>
                  <div class="mt-4">

                    <button
                        id="listar-kits-btn"
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="listarKits">Melhores Kit's
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </button>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Informações Iniciais</h4>

            <p
                class="text-muted mb-4"
            >Favor revisar todos os itens abaixo para concluir com sucesso seu orçamento.</p>
            <div class="table-responsive ">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Alerta 001:</th>
                  <td>Produto 001 incompatível com produto 002</td>
                </tr>
                <tr>
                  <th scope="row">Alerta 002:</th>
                  <td>Produto 011 incompatível com produto 020</td>
                </tr>
                <tr>
                  <th scope="row">Notificação 002:</th>
                  <td>Saldo de produto 002 indisponível</td>
                </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-5">Aprovações / Revisões</h4>
            <div class>
              <ul class="verti-timeline list-unstyled">
                <li class="event-list active">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-server h4 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">Aprovador 001</a>
                        </h5>
                        <span class="text-primary">01-04-2023</span>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-code h4 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">Aprovador 002</a>
                        </h5>
                        <span class="text-primary">01-04-2023</span>
                      </div>
                    </div>
                  </div>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">

        <Loader v-if="loadingKits" style="min-height: 300px;">
        </Loader>

        <div class="row" v-if="!loadingKits">
          <div
              v-for="data in produtosData"
              :key="data.id"
              class="col-xl-3 col-sm-4"
          >
            <div class="card">
              <div class="card-body" @click="selecionaKit" style="cursor: pointer;">
                <div class="product-img position-relative">
                  <div v-if="data.discount" class="avatar-sm product-ribbon">
                    <span class="avatar-title rounded-circle bg-primary"
                    >-{{ data.discount }}%</span
                    >
                  </div>

                    <img
                        :src="`${data.product}`"
                        alt
                        class="img-fluid mx-auto d-block"
                        style="max-width: 200px; min-height: 120px; object-fit: contain;"
                    />

                </div>
                <div class="mt-4 text-center" >
                  <h5 class="mb-3 text-truncate">
                    {{ data.name }}
                  </h5>
                  <p class="text-muted">
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star"></i>
                  </p>
                  <h5 class="my-0">
                    <span class="text-muted me-2">
                      {{ data.oldprice }}
                    </span>
                    <b>R$ {{ data.newprice }}</b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Composição de Orçamento (componentes)</h4>

            <Loader style="min-height: 150px;" v-if="loadingComponentes">
            </Loader>

            <div class="table-responsive" v-if="!loadingComponentes">
              <table class="table table-nowrap table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">Produto</th>
                  <th scope="col">Descrição</th>
                  <th scope="col">Disponível</th>
                  <th scope="col">Quantidade</th>
                  <th scope="col">Valor</th>
                </tr>
                </thead>
                <tbody @click="showModalComponente = true">

                <tr
                    v-for="compo in componentesData"
                    :key="compo.codigo">
                  <th scope="row">{{ compo.codigo }}</th>
                  <td>{{ compo.descricao }}</td>
                  <td>{{ compo.dtDisp }}</td>
                  <td>{{ compo.quantidade }}</td>
                  <td>R$ {{compo.valor }}</td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


      <div class="col-xl-12">
        <div class="text-end">
          <button type="button" class="btn btn-success" @click="sucesso">Sucesso</button>
        </div>
      </div>



      <b-modal title="Alteração de Componente" v-model="showModalComponente" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="produto">Produto</label>
                <input
                    id="produto"
                    type="text"
                    class="form-control"
                    value="CONTROLE REMOTO"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="quantidade">Quantidade</label>
                <input
                    id="quantidade"
                    type="number"
                    value="1"
                    class="form-control"
                    placeholder="CONTROLE REMOTO"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="valor">Valor</label>
                <input
                    id="valor"
                    type="number"
                    value="1000"
                    class="form-control"
                    placeholder="CONTROLE REMOTO"
                    readonly/>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="obs">Observações</label>
                <textarea
                    id="obs"
                    value=""
                    class="form-control"
                    name="textarea"
                    rows="3"
                ></textarea>
              </div>
            </div>
            <div class="mb-3">
              <label for="file">Anexar arquivo</label>
              <input
                  id="file"
                  type="file"
                  multiple
                  class="form-control"/>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModalComponente = false">Fechar</b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="showModalComponente = false">
              Confirmar
            </b-button>
          </div>
        </form>
      </b-modal>


    </div>
    <!-- end row -->
  </Layout>
</template>
